import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'

import alertIco from '../../../assets/alert.svg'
import { BORDER_RADIUS } from '../../../styles'
import { linkStyle } from '../../../styles/shared/link'
import { ALink } from '../../common/a-link'
import { Content } from '../../common/content'
import cs from './i18n/cs.json'
import en from './i18n/en.json'

const FallbackErrorStyled = styled.div`
  background: url(${alertIco}) ${({ theme }) => theme.colors.common.light.pink} no-repeat 20px 20px;
  border-radius: ${BORDER_RADIUS};
  color: ${({ theme }) => theme.colors.background.dark};
  padding: 20px 20px 20px 60px;
  text-align: left;
`

const RefreshButton = styled.button`
  ${linkStyle};
  padding: 0;
  border: none;
`

export const FallbackError = () => {
  const { t, i18n } = useTranslation('fallbackError')
  i18n.addResourceBundle('cs', 'fallbackError', cs)
  i18n.addResourceBundle('en', 'fallbackError', en)

  const refresh = () => window.location.reload()

  return (
    <Content contentWidth={'small'}>
      <FallbackErrorStyled data-testid={'fallback-error'}>
        <div>{t('MessageTitle')}</div>
        <div>
          <Trans i18nKey={'MessageText'} t={t}>
            Please try
            <RefreshButton type={'button'} onClick={refresh}>
              refreshing
            </RefreshButton>
            the page or contact us on <ALink href='tel:277207207'>277 207 207</ALink>
          </Trans>
        </div>
      </FallbackErrorStyled>
    </Content>
  )
}
